import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export const Testimonials = () => {
  const reviews = [{
    name: 'Олександр М.',
    text: 'Звернувся вночі, коли ситуація була критичною. Лікар приїхав через 40 хвилин. Дуже професійно, без зайвих питань, швидко поставили крапельницю. На ранок почувався зовсім інакше. Дякую за анонімність.',
    date: 'Місяць тому'
  }, {
    name: 'Ірина В.',
    text: "Лікували чоловіка в стаціонарі. Умови дійсно хороші, чисто, персонал ввічливий. Головне — є результат. Після курсу пройшов кодування, зараз не п'є вже півроку. Дуже вдячні лікарям клініки.",
    date: '3 місяці тому'
  }, {
    name: 'Анонімно',
    text: 'Викликав бригаду для виводу із запою. Сподобалось, що приїхали на звичайній машині, без мигалок, сусіди нічого не зрозуміли. Лікар був поруч кілька годин, поки стан не стабілізувався.',
    date: 'Тиждень тому'
  }];
  return <section id="testimonials" className="py-24 bg-[#F5F5F5] border-y border-gray-200" data-id="element-237">
      <div className="container mx-auto px-4 md:px-6" data-id="element-238">
        <FadeIn data-id="element-239">
          <div className="flex justify-between items-end mb-16" data-id="element-240">
            <h2 className="text-3xl md:text-5xl font-bold" data-id="element-241">Відгуки</h2>
            <div className="text-sm text-gray-500 hidden sm:block" data-id="element-242">
              *Всі відгуки публікуються анонімно за згодою пацієнтів
            </div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-243">
          {reviews.map((review, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-244">
              <div className="bg-white p-8 border border-gray-200 h-full flex flex-col" data-id="element-245">
                <Quote className="w-8 h-8 text-gray-200 mb-6" data-id="element-246" />
                <p className="text-gray-700 leading-relaxed mb-8 flex-grow" data-id="element-247">
                  "{review.text}"
                </p>
                <div className="flex justify-between items-center pt-6 border-t border-gray-100" data-id="element-248">
                  <span className="font-bold" data-id="element-249">{review.name}</span>
                  <span className="text-xs text-gray-400" data-id="element-250">{review.date}</span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};